import { IMasterConfigOption } from "../../store/apis/masterConfig.api";
import { IUserFilterItem } from "../../types";
import { MODULES } from "./constants";

function humanizeUnknownModuleCode(code: string): string {
  const t = code.trim();
  if (!t) return "";
  return t
    .split(/_+/)
    .filter(Boolean)
    .map((w) => {
      const lower = w.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}

export const getLabelValue = (options: IUserFilterItem[] | undefined, id: string) => {
  if (!options) return "";
  return options.find(opt => opt.id === id)?.fullName || "";
};

export const getStatusLabel = (options: IMasterConfigOption[] | undefined, id: string | undefined) => {
  if (!options || !id) return "";
  return options.find(opt => opt.id === id)?.displayName || "";
};

/**
 * Resolves the workflow "Module" label for a `permissionCode` from the API.
 * Matches both the constant **key** (e.g. `MY_PROFILE`) and each entry's `category_code`
 * (e.g. `EMPLOYEE_PROFILE`), since stored workflows use `category_code` values.
 */
export const getLabelForModules = (category_code: string) => {
  if (!MODULES || !category_code) return "";
  const byKey = MODULES[category_code as keyof typeof MODULES]?.label;
  if (byKey) return byKey;
  const fromCategory = Object.values(MODULES).find(
    (m) => m.category_code === category_code,
  )?.label;
  if (fromCategory) return fromCategory;
  return humanizeUnknownModuleCode(category_code);
};

